import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components'

import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import Item from "../../components/item"
import ItemAdd from "../../components/itemAdd"
import Header from "../../components/header"
import Search from "../../components/search"

import { Divver } from '../../components/Divver';

const H1 = styled.h1`
    font-size: 24px;
`

const VarAddBtn = styled(Link)`
    text-decoration: none;
`

const VarEditBtn = styled(Link)`
    text-decoration: none;
    color: #000000;
`

function GlobalVar() {
  const vars = useRef([])
  const [globalVar, setGlobalVar] = useState([])
  const [searchText, setSearchText] = useState("")

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("https://api.hyuns.dev/var/global", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        })
        vars.current = response.data.data
        setGlobalVar(vars.current)
      } catch (err) {
        console.log(err)
      }
    })()
  }, [])

  useEffect(() => {
    return () => setGlobalVar([]);
  }, []);

  useEffect(() => {
    setGlobalVar(vars.current.filter(e => {
      if (e.varGroup.includes(searchText) || e.varKey.includes(searchText)) {
        return true
      } else {
        return false
      }
    }))
  }, [searchText])

  return (
    <>
        
        <Divver>
        <Header title="공개 변수" to="/" />
            <H1>공개 변수</H1>
            <Search value={searchText} onChange={e => setSearchText(e.target.value)}/>
            {globalVar.map((e,i) => {
                return <VarEditBtn to={`/var/global/edit/${e.varGroup}/${e.varKey}`} key={i}><Item img={e.varImg} label={e.varGroup} content={e.varKey} message={e.varValue} /></VarEditBtn>
            })}
            <VarAddBtn to="/var/global/add"><ItemAdd /></VarAddBtn>
        </Divver>
    </>
  );
}

export default GlobalVar;
 